import React from "react";
import styled from "styled-components";

import { BrowserRouter, Route, Switch } from "react-router-dom";

import { OriginThemeProvider } from "@origin-digital/ods-core";
import { ErrorWrapper } from "./components/ErrorWrapper/ErrorWrapper";
import { Routes } from "./consts";
import { AppContextProvider } from "./context/AppContext";
import { CallbackScreen } from "./screens/CallbackScreen/CallbackScreen";
import { OffersScreen } from "./screens/OffersScreen/OffersScreen";
import { ThankYouScreen } from "./screens/ThankYouScreen/ThankYouScreen";
import { ScrollToTop } from "./components/ScrollToTop/ScrollToTop";
import { ProofPointsProvider } from "./context/ProofPointsContext";
import { KasadaIntegration } from "./kasada/KasadaIntegration";

// Fixes leaking styles from Wordpress
const WordpressGlobalStyleFixes = styled.div`
  // input box-sizing attribute is being overridden with border-box

  input {
    box-sizing: content-box;
  }

  // increase specificity to override Wordpress spacing and background on list items

  &.lpgoffers[data-id="lpgoffers"] {
    background-color: transparent !important;

    ul li {
      margin-bottom: 0;
      padding-left: 0;
    }
  }
`;

export const Root = () => (
  <OriginThemeProvider>
    <ErrorWrapper>
      <KasadaIntegration />
      <AppContextProvider>
        <ProofPointsProvider>
          <WordpressGlobalStyleFixes data-id="lpgoffers" className="lpgoffers">
            <BrowserRouter basename={window.location.pathname}>
              <ScrollToTop />
              <Switch>
                <Route path="/" exact component={OffersScreen} />
                <Route
                  path={Routes.REQUEST_CALLBACK}
                  exact
                  component={CallbackScreen}
                />
                <Route
                  path={Routes.THANK_YOU}
                  exact
                  component={ThankYouScreen}
                />
              </Switch>
            </BrowserRouter>
          </WordpressGlobalStyleFixes>
        </ProofPointsProvider>
      </AppContextProvider>
    </ErrorWrapper>
  </OriginThemeProvider>
);
